import { Injectable } from '@angular/core';
import { catchError, map } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { ApiService } from '../core';
import { HandleError, HttpErrorHandler } from '../http-error-handler.service';
import { Invoice, Pedido } from '../modelo/Invoice';
import { Retencion } from '../modelo/Retencion';

import { HttpHeaders, HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class ComprobantesService {

    private apiServer = '';
    private handleError: HandleError;

    constructor(
        private http: HttpClient,
        private apiService: ApiService, httpErrorHandler: HttpErrorHandler
    ) {
        this.apiServer = environment.settings.apiServer;
        this.handleError = httpErrorHandler.createHandleError('ComprobantesService');
    }

    /*************************************************************************************
    **REQUEST HTTP
    **************************************************************************************/
    /**
    * Retorna la lista de comprobantes activos del tipo <tt>tipo</tt>
    */
    getComprobantesPorUsuarioConectadoData(): Promise<any> {
        return this.getFacturasEmitidasPorUsuarioConectado().toPromise();
    }
    getComprobantesPorUsuarioConectado(tipo: string) {
        return this.apiService.get(this.apiServer + '/comprobantes/' + tipo)
            .pipe(
                catchError(this.handleError('ComprobantesService.getComprobantesPorUsuarioConectado'))
            )
    }

    enviarFactura(factura: Invoice) {
        return this.apiService.post(this.apiServer + '/comprobantes/facturas', factura)
            .pipe(map(data => data));
    }

    notificarFactura(tipo: string, factura: Invoice) {
        return this.apiService.put(`${this.apiServer}/comprobantes/${tipo}/${factura.claveAcceso}/notificar`, factura)
            .pipe(map(data => data));
    }

    getComprobantesEnviadasRecibidasPorUsuarioConectadoData(): Promise<any> {
        return this.getComprobantesEnviadasRecibidasPorUsuarioConectado().toPromise();
    }
    getComprobantesEnviadasRecibidasPorUsuarioConectado() {
        return this.apiService.get(this.apiServer + '/facturacion')
            .pipe(
                catchError(this.handleError('ComprobantesService.getComprobantesEnviadasRecibidasPorUsuarioConectado'))
            )
    }




    getComprobantesEnviadasRecibidasPorUsuarioConectadoFiltrarData(busqueda:string, establecimiento:string, puntoemision: string, estado:string, fechainicio: Date, fechafin: Date): Promise<any> {
        return this.getComprobantesEnviadasRecibidasPorUsuarioConectadoFiltrar(busqueda, establecimiento, puntoemision, estado, fechainicio, fechafin).toPromise();
    }
    getComprobantesEnviadasRecibidasPorUsuarioConectadoFiltrar(busqueda:string, establecimiento:string, puntoemision: string, estado:string, fechainicio: Date, fechafin: Date) {
        
         const params = new HttpParams()
            .set('busqueda', busqueda ? busqueda : '')
            .set('establecimiento', establecimiento ? establecimiento : '')
            .set('puntoemision', puntoemision ? puntoemision : '')
            .set('estado', estado ? estado : 'APPLIED')
            .set('fechainicio', fechainicio.toLocaleDateString())
            .set('fechafin', fechafin.toLocaleDateString());
        return this.apiService.get(this.apiServer + '/facturacion/filtrar', params)
            .pipe(
                catchError(this.handleError('ComprobantesService.getComprobantesEnviadasRecibidasPorUsuarioConectadoFiltrar'))
            )
    }
    
    getComprobantesPreInvoicePorUsuarioConectadoFiltrarData(busqueda:string, establecimiento:string, puntoemision: string, estado:string, fechainicio: Date, fechafin: Date): Promise<any> {
        return this.getComprobantesPreInvoicePorUsuarioConectadoFiltrar(busqueda, establecimiento, puntoemision, estado, fechainicio, fechafin).toPromise();
    }
    
    getComprobantesPreInvoicePorUsuarioConectadoFiltrar(busqueda:string, establecimiento:string, puntoemision: string, estado:string, fechainicio: Date, fechafin: Date) {
        
        const params = new HttpParams()
            .set('busqueda', busqueda ? busqueda : '')
            .set('establecimiento', establecimiento ? establecimiento : '')
            .set('puntoemision', puntoemision ? puntoemision : '')
            .set('fechainicio', fechainicio.toLocaleDateString())
            .set('fechafin', fechafin.toLocaleDateString())
            .set('estado', estado ? estado : 'APPLIED');
        return this.apiService.get(this.apiServer + '/pos/filtrar', params)
            .pipe(
                catchError(this.handleError('ComprobantesService.getComprobantesPreInvoicePorUsuarioConectadoFiltrar'))
            )
    }
    
    /** DEPRECATED */
    getComprobantesPreInvoicePorUsuarioConectadoYEstadoData(busqueda:string, fechainicio: Date, fechafin: Date, estado: string): Promise<any> {
        return this.getPreInvoicePorUsuarioConectadoYEstado(busqueda, fechainicio, fechafin, estado).toPromise();
    }
    /** DEPRECATED */
    getPreInvoicePorUsuarioConectadoYEstado(busqueda:string, fechainicio: Date, fechafin: Date, estado: string) {
        const params = new HttpParams()
            .set('busqueda', busqueda ? busqueda : '')
            .set('fechainicio', fechainicio.toLocaleDateString())
            .set('fechafin', fechafin.toLocaleDateString())
            .set('estado', estado ? estado : 'APPLIED');
        return this.apiService.get(this.apiServer + '/pos/filtrar', params)
            .pipe(
                catchError(this.handleError('ComprobantesService.getPreInvoicePorUsuarioConectadoYEstado'))
            )
    }

    getFacturasEmitidasPorUsuarioConectado() {
        return this.apiService.get(this.apiServer + '/facturacion/facturas/emitidas/activos')
            .pipe(
                catchError(this.handleError('ComprobantesService.getFacturasEmitidasPorUsuarioConectado'))
            )
    }

    getComprobantesPorUsuarioConectadoYEstadoData(estado: string): Promise<any> {
        return this.getFacturasEmitidasPorUsuarioConectadoYEstado(estado).toPromise();
    }
    getFacturasEmitidasPorUsuarioConectadoYEstado(estado: string) {
        return this.apiService.get(this.apiServer + '/facturacion/facturas/emitidas/estado/' + estado + '/activos')
            .pipe(
                catchError(this.handleError('ComprobantesService.getFacturasEmitidasPorUsuarioConectadoYEstado'))
            )
    }

    getComprobantesRechazadosPorUsuarioConectadoData(): Promise<any> {
        return this.getFacturasEmitidasRechazadasPorUsuarioConectado().toPromise();
    }
    getFacturasEmitidasRechazadasPorUsuarioConectado() {
        return this.apiService.get(this.apiServer + '/facturacion/facturas/emitidas/rechazados')
            .pipe(
                catchError(this.handleError('ComprobantesService.getFacturasEmitidasRechazadasPorUsuarioConectado'))
            )
    }

    getComprobantesParaUsuarioConectadoData(): Promise<any> {
        return this.getFacturasRecibidasPorUsuarioConectado().toPromise();
    }
    getFacturasRecibidasPorUsuarioConectado() {
        return this.apiService.get(this.apiServer + '/facturacion/facturas/recibidas/activos')
            .pipe(
                catchError(this.handleError('ComprobantesService.getFacturasRecibidasPorUsuarioConectado'))
            )
    }

    /**Compras registradas (facturas recibidas), incluidas las importadas del SRI*/
    getComprasRecibidasData(): Promise<any> {
        return this.getComprasRecibidas().toPromise();
    }
    getComprasRecibidas() {
        return this.apiService.get(this.apiServer + '/compras/recibidas')
            .pipe(
                catchError(this.handleError('ComprobantesService.getComprasRecibidas', []))
            )
    }

    /**Importa comprobantes recibidos del SRI a partir de sus claves de acceso*/
    importarComprobantesSRI(claves: string[]) {
        return this.apiService.post(this.apiServer + '/compras/importar-sri', { claves: claves });
    }

    getFacturaData(uuid: string): Promise<any> {
        return this.getFactura(uuid).toPromise();
    }
    getFactura(uuid: string) {
        return this.apiService.get(this.apiServer + '/facturacion/facturas/' + uuid)
            .pipe(
                catchError(this.handleError('ComprobantesService.getFactura'))
            )
    }
    

    enviarFacturaPago(factura: Invoice) {
        return this.apiService.put(this.apiServer + '/facturacion/facturas/pago', factura)
            .pipe(map(data => data));
    }

    enviarFacturaAnulada(factura: Invoice) {
        return this.apiService.put(this.apiServer + '/facturacion/facturas/anular', factura)
            .pipe(map(data => data));
    }

    cargarDataReemitirFactura(factura: Invoice) {
        return this.apiService.put(this.apiServer + '/facturacion/factura/data/reemitir', factura)
            .pipe(map(data => data));
    }

    cargarDataFacturaNueva(factura: Invoice) {
        return this.apiService.put(this.apiServer + '/facturacion/factura/data/nueva', factura)
            .pipe(map(data => data));
    }

    getFacturaAPartirDeData(uuid: string): Promise<any> {
        return this.getFacturaAPartirDe(uuid).toPromise();
    }
    getFacturaAPartirDe(uuid: string) {
        return this.apiService.get(this.apiServer + '/facturacion/factura/data/nueva/' + uuid)
            .pipe(
                catchError(this.handleError('ComprobantesService.getFacturaAPartirDe'))
            )
    }

    generarComprobante(tipo: string, claveAcceso: string) {
        return this.apiService.get(this.apiServer + '/comprobantes/' + tipo + '/' + claveAcceso + '/archivos/pdf')
            .pipe(map(data => data));
    }

    getProformaData(uuid: string): Promise<any> {
        return this.getProforma(uuid).toPromise();
    }
    
    getProforma(uuid: string) {
        return this.apiService.get(`${this.apiServer}/pos/proformas/${uuid}/facturar`)
            .pipe(
                catchError(this.handleError('ComprobantesService.getProforma'))
            )
    }
    
    marcarDesmarca(pedido: Pedido, estado:string) {
        return this.apiService.put(`${this.apiServer}/pos/pedidos/estado/${estado}`, pedido)
            .pipe(map(data => data));
    }
    
    private formatErrors(error: any) {
        return throwError(error.error);
    }

    downloadRIDE(tipo: string, claveAcceso: string, params: HttpParams = new HttpParams()): Observable<any> {
        const path: string = this.apiServer + '/comprobantes/' + tipo + '/' + claveAcceso + '/archivos/pdf';
        return this.http.get(`${path}`, { params, responseType: 'blob' })
            .pipe(catchError(this.formatErrors));;
    }
    
    downloadVeroinicaRIDE(tipo: string, claveAcceso: string, params: HttpParams = new HttpParams()): Observable<any> {
        const path: string = this.apiServer + '/comprobantes/' + tipo + '/' + claveAcceso + '/veronica/pdf';
        return this.http.get(`${path}`, { params, responseType: 'blob' })
            .pipe(catchError(this.formatErrors));;
    }

    downloadXML(tipo: string, claveAcceso: string, params: HttpParams = new HttpParams()): Observable<any> {
        const path: string = this.apiServer + '/comprobantes/' + tipo + '/' + claveAcceso + '/archivos/xml';
        return this.http.get(`${path}`, { params, responseType: 'blob' })
            .pipe(catchError(this.formatErrors));;
    }

    getPaymentMethodsData(): Promise<any> {
        return this.getPaymentMethods().toPromise();
    }
    getPaymentMethods() {
        return this.apiService.get(this.apiServer + '/comprobantes/metodospago')
            .pipe(
                catchError(this.handleError('ComprobantesService.getPaymentMethods'))
            )
    }

    getTiposComprobantesData(): Promise<any> {
        return this.getTiposComprobantes().toPromise();
    }
    getTiposComprobantes() {
        return this.apiService.get(this.apiServer + '/comprobantes/tipocomprobantes')
            .pipe(
                catchError(this.handleError('ComprobantesService.getTiposComprobantes'))
            )
    }

    getTiposImpuestosData(): Promise<any> {
        return this.getTiposImpuestosRetentecionRenta().toPromise();
    }

    getTiposImpuestosRetentecionRenta() {
        return this.apiService.get(this.apiServer + '/comprobantes/tipoimpuestos/retencion-renta')
            .pipe(
                catchError(this.handleError('ComprobantesService.tipoimpuestos'))
            )
    }

    getTiposRetencionesIVAData(): Promise<any> {
        return this.getTiposRetencionesIVA().toPromise();
    }

    getTiposRetencionesIVA() {
        return this.apiService.get(this.apiServer + '/comprobantes/retencion/retencion-iva')
            .pipe(
                catchError(this.handleError('ComprobantesService.getTiposRetencionesIVA'))
            )
    }

    //Notas de credito

    enviarNotasCredito(factura: Invoice) {
        return this.apiService.post(this.apiServer + '/comprobantes/notas-credito', factura)
            .pipe(map(data => data));
    }

    getNotasCreditoEnviadasRecibidasPorUsuarioConectadoData(): Promise<any> {
        return this.getNotasCreditoEnviadasRecibidasPorUsuarioConectado().toPromise();
    }
    getNotasCreditoEnviadasRecibidasPorUsuarioConectado() {
        return this.apiService.get(this.apiServer + '/facturacion/notas-credito')
            .pipe(
                catchError(this.handleError('ComprobantesService.getNotasCreditoEnviadasRecibidasPorUsuarioConectado'))
            )
    }

    getNotasCreditoPorUsuarioConectadoYEstadoData(estado: string): Promise<any> {
        return this.getNotasCreditoPorUsuarioConectadoYEstado(estado).toPromise();
    }
    getNotasCreditoPorUsuarioConectadoYEstado(estado: string) {
        return this.apiService.get(this.apiServer + '/facturacion/facturas/notas-credito/emitidas/estado/' + estado + '/activos')
            .pipe(
                catchError(this.handleError('ComprobantesService.getNotasCreditoPorUsuarioConectadoYEstado'))
            )
    }

    getNotasCreditoParaUsuarioConectadoData(): Promise<any> {
        return this.getNotasCreditoRecibidasPorUsuarioConectado().toPromise();
    }
    getNotasCreditoRecibidasPorUsuarioConectado() {
        return this.apiService.get(this.apiServer + '/facturacion/facturas/notas-credito/recibidas/activos')
            .pipe(
                catchError(this.handleError('ComprobantesService.getNotasCreditoRecibidasPorUsuarioConectado'))
            )
    }

    enviarNotaCreditoAnulada(factura: Invoice) {
        return this.apiService.put(this.apiServer + '/facturacion/facturas/notas-credito/anular', factura)
            .pipe(map(data => data));
    }

    //Retenciones
    //Notas de credito

    enviarRetencion(retencion: Retencion) {
        return this.apiService.post(this.apiServer + '/comprobantes/retenciones', retencion)
            .pipe(map(data => data));
    }

    getRetencionesEnviadasRecibidasPorUsuarioConectadoData(): Promise<any> {
        return this.getRetencionesEnviadasRecibidasPorUsuarioConectado().toPromise();
    }

    getRetencionesEnviadasRecibidasPorUsuarioConectado() {
        return this.apiService.get(this.apiServer + '/facturacion/retenciones')
            .pipe(
                catchError(this.handleError('ComprobantesService.getRetencionEnviadasRecibidasPorUsuarioConectado'))
            )
    }

    getRetencionesPorUsuarioConectadoYEstadoData(estado: string): Promise<any> {
        return this.getRetencionesEmitidasPorUsuarioConectadoYEstado(estado).toPromise();
    }
    getRetencionesEmitidasPorUsuarioConectadoYEstado(estado: string) {
        return this.apiService.get(this.apiServer + '/facturacion/facturas/retenciones/emitidas/estado/' + estado + '/activos')
            .pipe(
                catchError(this.handleError('ComprobantesService.getFacturasEmitidasPorUsuarioConectadoYEstado'))
            )
    }
    
    getGuiasRemisionEnviadasRecibidasPorUsuarioConectadoFiltrarData(busqueda:string, fechainicio: Date, fechafin: Date): Promise<any> {
        return this.getGuiasRemisionEnviadasRecibidasPorUsuarioConectadoFiltrar(busqueda, fechainicio, fechafin).toPromise();
    }
    getGuiasRemisionEnviadasRecibidasPorUsuarioConectadoFiltrar(busqueda:string, fechainicio: Date, fechafin: Date) {
        
         const params = new HttpParams()
            .set('busqueda', busqueda ? busqueda : '')
            .set('fechainicio', fechainicio.toLocaleDateString())
            .set('fechafin', fechafin.toLocaleDateString());
        return this.apiService.get(this.apiServer + '/facturacion/guias-remision/filtrar', params)
            .pipe(
                catchError(this.handleError('ComprobantesService.getGuiasRemisionEnviadasRecibidasPorUsuarioConectadoFiltrar'))
            )
    }


    //Auxiliares

    getTiposDocumentosIdentidadData(): Promise<any> {
        return this.getTiposDocumentosIdentidad().toPromise();
    }
    getTiposDocumentosIdentidad() {
        return this.apiService.get(this.apiServer + '/comprobantes/tipocomprobantes')
            .pipe(
                catchError(this.handleError('ComprobantesService.getTiposDocumentosIdentidad'))
            )
    }


    getSRIMensajesData(claveacceso: string, tabla: string): Promise<any> {
        return this.getSRIMensajes(claveacceso, tabla).toPromise();
    }

    getSRIMensajes(claveacceso: string, tabla: string) {
        return this.apiService.get(this.apiServer + '/comprobantes/errores/' + claveacceso + '/tipo/' + tabla)
            .pipe(
                catchError(this.handleError('ComprobantesService.getSRIMensajes'))
            )
    }
}